import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecipients = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 20,
	viewBox: "0 0 15 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.02566 15.9044H7.10755C6.93865 15.9044 6.80151 15.7673 6.80151 15.5984V14.4293H8.3317V15.5984C8.3317 15.7673 8.19457 15.9044 8.02566 15.9044Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5291 15.3368C14.8245 15.6534 14.9998 16.0759 14.9998 16.5286V19.239C14.9998 19.4805 14.8039 19.6764 14.5624 19.6764H12.3762V18.214C12.3762 17.7501 12.5605 17.3054 12.8882 16.9771L14.5291 15.3368Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.94312 11.9727C5.71562 12.4201 6.60991 12.6806 7.56667 12.6806C8.52344 12.6806 9.41772 12.4201 10.1902 11.9727V10.4944H4.94312V11.9727Z",
			fill: "#A3B8C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8483 14.8846L10.1902 13.5546L7.56663 14.4293L4.94307 13.5546L1.28438 14.8851C0.593416 15.1361 0.133301 15.7932 0.133301 16.5286V19.239C0.133301 19.4805 0.329207 19.6764 0.570649 19.6764H14.5626C14.804 19.6764 15 19.4805 15 19.239V16.5286C14.9994 15.7932 14.5398 15.1361 13.8483 14.8846Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.3764 0.874696V4.53762C12.3764 4.74859 12.361 4.95903 12.3306 5.16725C12.3037 5.35194 12.265 5.53489 12.2146 5.71492C12.1954 5.78375 12.1745 5.85216 12.1519 5.92008L12.0063 6.3569C11.9618 6.49033 11.939 6.63064 11.939 6.77148V6.99598H11.9388H7.08407H3.19418V6.77148C3.19418 6.63064 3.17142 6.49086 3.12694 6.3569L2.98133 5.92008C2.83255 5.47426 2.75684 5.00779 2.75684 4.53762V3.49772C2.75684 1.56619 4.32303 0 6.25456 0H6.71926H11.5015H11.5017C11.9851 0 12.3764 0.391813 12.3764 0.874696Z",
			fill: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.19 10.4944H4.94287V14.4295H10.19V10.4944Z",
			fill: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.56661 14.4292L6.17197 15.8238C5.98454 16.0113 5.67479 15.9901 5.51436 15.7788L4.06836 13.8738L4.44641 13.0769C4.55813 12.8418 4.84934 12.7555 5.07066 12.8921L7.56661 14.4292Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.56665 14.4292L8.96129 15.8238C9.14873 16.0113 9.45847 15.9901 9.6189 15.7788L11.0649 13.8738L10.6869 13.0769C10.5751 12.8418 10.2839 12.7555 10.0626 12.8921L7.56665 14.4292Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.44419 8.89385C4.04528 10.5905 5.66401 11.8057 7.56673 11.8057C9.98167 11.8057 11.9391 9.84765 11.9397 7.43323V6.9207C11.9397 6.68879 11.8476 6.46641 11.6834 6.30227L11.3213 5.94011C11.1571 5.77597 11.065 5.55359 11.065 5.32168V5.08924C11.065 4.91292 10.9866 4.74137 10.8442 4.63654C8.78201 3.11982 5.80805 3.54452 4.60466 3.80305C4.52976 3.81904 4.46175 3.83442 4.40134 3.84872C4.20437 3.89531 4.0683 4.0711 4.0683 4.27336V5.32119C4.0683 5.5531 3.97617 5.77548 3.81203 5.93962L3.44987 6.30178C3.28573 6.46592 3.1936 6.6883 3.1936 6.92021V7.43222C3.1936 7.94495 3.28193 8.43693 3.44419 8.89385Z",
			fill: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.604006 15.3368C0.308558 15.6539 0.133301 16.0759 0.133301 16.5286V19.239C0.133301 19.4805 0.329207 19.6764 0.570649 19.6764H2.75686V18.214C2.75686 17.7501 2.5726 17.3054 2.24432 16.9771L0.604006 15.3368Z",
			fill: "#FF3131"
		})
	]
});
export default SvgRecipients;
